var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-echart',_vm._b({ref:"baseEchart",attrs:{"options":_vm.mergeOptions}},'base-echart',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }